// extracted by mini-css-extract-plugin
var _1 = "AVg39DO6";
var _2 = "AVg39DO6";
export { _1 as "product-categories", _2 as "productCategories" }
